import React, { Dispatch, FC, SetStateAction, useEffect, useState } from 'react';
import styled from 'styled-components';
import { BreakpointsEnum, IFilter } from '@app/types';
import Filters from '@app/ui/components/Filters';
import { filterIcons } from '../constants';
import { mergeFilterIcons } from '../utils';
import { useAppSelector } from '@app/store/hooks';
import { selectors } from '@app/store';
import { useSelector } from 'react-redux';

interface Props {
  initialFilters?: IFilter[];
  className?: string;
  applyAndSaveAllSelectedFilters: (p?: number, childOld?: number, therapistOld?: string) => void;
  childTherapists?: boolean;
	isSupervisorTherapist?:boolean;
  childAge?: number;
  setChildAge?: Dispatch<SetStateAction<number>>;
  therapistAge?: string | undefined;
  setTherapistAge?: Dispatch<SetStateAction<string | undefined>>;
  therapistsPage?: boolean;
}

const Sidebar: FC<Props> = (props: Props) => {
  const { className, initialFilters, isSupervisorTherapist, childTherapists, childAge, setChildAge, therapistAge, setTherapistAge, therapistsPage } = props;


  const selectedFilters = useAppSelector(
    selectors.allTherapistsFilters.selectSelectedFilters,
  );

  const therapyMethods = useSelector(
    selectors.allTherapistsFilters.selectTherapyMethods,
  );

  const diseasesGroups = useSelector(
    selectors.allTherapistsFilters.selectDiseasesGroups,
  );

  const selectedFiltersValues = useAppSelector(
    selectors.allTherapistsFilters.selectSelectedFiltersValues,
  );

  const filters: IFilter[] | undefined = initialFilters;
  // const filters = useSelector(selectors.allTherapistsFilters.selectFilters);

  const [filtersToShow, setFiltersToShow] = useState<IFilter[] | undefined>(
    selectedFilters || filters,
  );
  const [mergedFiltersWithIcons, setMergedFiltersWithIcons] =
    useState<any>(filters);

  // const [childAge, setChildAge] = useState<number>(8);
  // const [therapistAge, setTherapistAge] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!therapyMethods || !diseasesGroups || !filters) {
      return;
    }
    const newFiltersToShow = selectedFilters || filters;
    setFiltersToShow(newFiltersToShow);
    const mfi = mergeFilterIcons(filterIcons, newFiltersToShow);
    setMergedFiltersWithIcons(mfi);
  }, [
    filters,
    selectedFilters,
    selectedFiltersValues,
    therapyMethods,
    diseasesGroups,
  ]);

  const handleReset = () => {
    const urlWithoutFilters = childTherapists ? '/child-therapists' : '/all-therapists/';
    const currentDomain = window.location.origin;
    const urlWithParams = `${currentDomain}${urlWithoutFilters}`;
    window.location.href = urlWithParams;
  };

  return (
    <Root className={className} $therapistsPage={therapistsPage}>
      {filtersToShow && mergedFiltersWithIcons && (
        <StyledFilters
          filters={mergedFiltersWithIcons}
          onApplying={() => {
            props?.applyAndSaveAllSelectedFilters &&
              props.applyAndSaveAllSelectedFilters(1, childTherapists ? childAge : undefined, therapistAge);
          }}
          onReset={handleReset}
          childTherapists={childTherapists}
          isSupervisorTherapist={isSupervisorTherapist}
          childAge={childAge}
          setChildAge={setChildAge}
          therapistAge={therapistAge}
          setTherapistAge={setTherapistAge}
        />
      )}
    </Root>
  );
};

const Root = styled.div<{ $therapistsPage: boolean | undefined }>`
  width: 100%;
  max-width: ${({ $therapistsPage }) =>
    $therapistsPage ? '280px' : '260px'};
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-width: ${BreakpointsEnum.sm}px) {
    max-width: 100%;
    min-height: 100%;
  }
`;

const StyledFilters = styled(Filters)`
  margin-bottom: 24px;
  @media (max-width: ${BreakpointsEnum.sm}px) {
    margin-bottom: 0;
  }
`;

export default Sidebar;
